import React from "react";
import {
  Box,
  CircularProgress,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import PropTypes from "prop-types";
import CustomDatePicker from "./CustomDatePicker";
import DateRangeIcon from "@mui/icons-material/DateRange";

const dateOption = {
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
  hour12: false,
  timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  timeZoneName: "short",
};

export const DateTimeAvailableExtension = ({
  available_until,
  onDateChange,
  loading,
  saved,
}) => {
  const theme = useTheme();
  return (
    <Box width="100%" mb={2}>
      <Box display="flex" alignItems="flex-start">
        <DateRangeIcon
          style={{
            color: theme.palette.primary.main,
          }}
          fontSize="large"
        />
        <Stack direction="column">
          <Typography
            color="primary"
            fontWeight="bold"
            whiteSpace="nowrap"
            ml={1}
          >
            Available Until
          </Typography>
          <Typography color="text.primary" fontSize="medium" ml={1}>
            {new Date(available_until + "Z").toLocaleString(
              "en-US",
              dateOption
            )}
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" ml={1} mt={1}>
          <CustomDatePicker
            available_until={available_until}
            onDateChange={onDateChange}
            theme={theme}
          />
          {loading && <CircularProgress size={20} mt={1} />}
          {saved && !loading && (
            <Typography color="success.main" fontSize="small" mt={1}>
              ✓
            </Typography>
          )}
        </Stack>
      </Box>
    </Box>
  );
};

DateTimeAvailableExtension.propTypes = {
  available_until: PropTypes.any,
  onDateChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  saved: PropTypes.bool,
};
